import React from 'react'
import Proptypes from 'prop-types'
import './index.less'
import { Toast } from 'antd-mobile'
import Vswiper from '@/compontents/Vswiper'
import Mysubmit from '@/compontents/submit'
import GeneralButton from '@/compontents/submit/GeneralButton'
import ProductIndex from '@/compontents/ProductIndex'
import ProductMixed from '@/compontents/ProductMixed'
import Product from '@/compontents/Product'
import Floor from '@/compontents/Floor'
import Title from '@/compontents/Title'
import QuickEntry from '@/compontents/QuickEntry'
// import Download from '@/compontents/Download'
import Share from './../../compontents/share/index'
import InvitePanel from './../../compontents/invitePanel/index'
import InviterInfo from './../../compontents/inviterInfo/index'
import ActivitySlider from './../../compontents/rushBuyingCompontents/ActivitySlider/index'
import Broadcast from './../../compontents/rushBuyingCompontents/Broadcast/index'
import ProductItem from './../../compontents/rushBuyingCompontents/ProductItem/index'
import InvestRecord from './../../compontents/rushBuyingCompontents/InvestRecord/index'
import InvestmentDialog from './../../compontents/rushBuyingCompontents/InvestmentDialog/index'
import ActivityRuleDialog from './../../compontents/rushBuyingCompontents/ActivityRuleDialog/index'
import StaticDiagram from './../../compontents/StaticDiagram'
import ProductMixedByPlus from './../../compontents/plusPageCompontents/ProductMixedByPlus/index'
import ShoppingMallYika from '../../compontents/plusPageCompontents/ShoppingMallYika'
import TitlePlus from '../../compontents/plusPageCompontents/TitlePlus'
import DebtTransfer from '../../compontents/plusPageCompontents/DebtTransfer'
import CardYika from '../../compontents/plusPageCompontents/CardYika'
import MyAsset from '../../compontents/plusPageCompontents/MyAsset'
import Notice from '../../compontents/plusPageCompontents/Notice'
import axios from 'axios'
import { setLogin, device, goIndex } from './../../assets/js/utils'
import WealthManagementCard from '../../compontents/walletPage/wealthManagementCard'
import BusinessTemplate from '../../compontents/walletPage/businessTemplate'
import SanlianProducts from '../../compontents/walletPage/sanlianProducts'
import GoldTD from '../../compontents/walletPage/goldTD'
import LoanTwoColumns from '../../compontents/walletPage/loanTwoColumns'
import EmployeeEntrance from '../../compontents/plusPageCompontents/EmployeeEntrance'

let websocket = null

class ConfigPage extends React.Component {
    static propTypes = {
        list: Proptypes.array,
        titleData: Proptypes.object,
        productList: Proptypes.array,
        timeDiff: Proptypes.number,
        businessLine: Proptypes.string,
        activityId: Proptypes.string

    }

    constructor (props) {
        super(props)
        const isWenue = props.list.find(item => item.templateType === 'TPL_ACTIVITY_VENUE_SLIDER')
        this.state = {
            isShow: false, // .wrap是否有padding-bottom,当有吸底按钮或者下载则为true
            showDownload: true, // 是否显示下载
            showBottom: false, // 是否有吸底按钮
            isShareComponent: false, // 是否有分享组件
            activitySliderList: isWenue ? isWenue.sublist : [],
            currentVenue: isWenue ? isWenue.sublist.find(item => item.selectStatus === 1) : {},
            restQuotaBySocket: {}, // 推送产品剩余额度
            broadcastList: [], // 投资播报列表
            InvestRecordList: [], // 投资记录列表
            showInvestRecord: false, // 是否显示投资记录弹窗：默认是false
            isLogin: false, // 用户是否登录
            showActivityRule: false, // 是否显示活动规则弹窗：默认是false
            activityRuleContent: '',
            ruleContentTitle: '',
            investRecordTitle: '',
            productList: props.productList || [],
            popupVisible: false,
            setIntervalObj: null,
            encryptionStatus: false// 总财富以及各业务线模板金额是否加密
        }
    }

    // 点击下载组件的关闭,showDownload为false
    // 只有下载则,isShow为false
    // 有吸底按钮则isShow为true
    closeDownload () {
        const { showBottom } = this.state
        this.setState({
            showDownload: false,
            isShow: !!showBottom
        })
    }

    // 解决IOS页面卡顿
    fixPageUnScroll () {
        const wrap = document.body
        wrap.addEventListener('touchstart', () => {
            const scrollTop = wrap.scrollTop
            const wrapScrollHeight = wrap.scrollHeight
            const wrapClentHeight = wrap.clientHeight
            if (scrollTop === 0) {
                wrap.scrollTop = 1
            }
            if (scrollTop === wrapScrollHeight - wrapClentHeight) {
                wrap.scrollTop = wrapScrollHeight - wrapClentHeight - 1
            }
        })
    }

    // 判断是否有 吸底按钮或者下载,有则isShow为true
    // showBottom为是否有吸底按钮
    componentDidMount () {
        const params = new URLSearchParams(window.location.search)
        const isPreview = params.get('isPreview')
        const isUc = device.isUCBrowser
        const { list = [], titleData = {} } = this.props
        const showBottom = list.filter(o => o.templateType === 'TPL_BOTTOM_BUTTON').length
        const isShow = showBottom > 0 || titleData.isBootDownload === '1'
        const isShareComponent = list.filter(o => o.templateType === 'TPL_INVITE_SHARE').length
        const isWenue = list.find(item => item.templateType === 'TPL_ACTIVITY_VENUE_SLIDER')
        const venueList = isWenue ? isWenue.sublist : null
        this.setState({
            isShow,
            showBottom,
            isShareComponent,
            isUc: isUc
        })

        // 解决页面无法滑动
        this.fixPageUnScroll()

        // 抢购活动链接webSocket
        if (titleData && titleData.activityId && venueList && venueList[venueList.length - 1].venueStatus !== 3 && !isPreview) {
            this.createWebsocket(titleData.activityId)
        }
        // 判断是否登录
        if (!device.isGomePlus) {
            this.checkLogin()
        }
    }

    // 判断用户现在的状态
    checkLogin = () => {
        axios.get('/gateway/v3/user/info')
            .then(v => {
                if (v.data.code === '401') {
                    this.setState({
                        isLogin: false
                    })
                }
                if (v.data.code === '200') {
                    this.setState({
                        isLogin: true
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    // 创建websocket链接
    createWebsocket = (activityId) => {
        const _me = this
        const { list } = this.props
        const businessLine = list.find(item => item.templateType === 'TPL_ACTIVITY_VENUE_PRODUCT_LIST')
            ? list.find(item => item.templateType === 'TPL_ACTIVITY_VENUE_PRODUCT_LIST').sublist[0].businessLine : ''
        // const maxLimit = list.find(item=>item.templateType === 'TPL_INVEST_BROADCAST').sublist[0].maxLimit;
        const url = `${process.env.REACT_APP_SOCKET_URL}gateway/websocket/v1/activity?activityId=${activityId}`
        const parma = {
            isSendQuota: '1',
            activityId: activityId,
            investBroadcast: [
                {
                    businessLine,
                    maxLimit: '10'
                }
            ]
        }

        if ('WebSocket' in window) {
            websocket = new WebSocket(url)
        } else {
            console.log('Not support websocket')
            return
        }
        websocket.onopen = function () {
            console.log('服务已链接')
            websocket.send(JSON.stringify(parma))
        }
        websocket.onmessage = (msg) => {
            _me.message(msg.data)
        }
        websocket.initiativeClose = (strUrl) => {
            websocket.close(1000, strUrl)
        }
        websocket.onclose = function (e) {
            console.log('websocket关闭了状态码' + e.code + '原因' + e.reason + '是否正常断开' + e.wasClean)
            _me.reconnect()
        }
        websocket.onerror = function (event) {
            console.log('websocket出错了')
        }
        clearInterval(_me.state.setIntervalObj)
        _me.state.setIntervalObj = setInterval(function () {
            const { activitySliderList } = _me.state
            if (activitySliderList && activitySliderList[activitySliderList.length - 1].venueStatus !== 3) {
                websocket.send('ping')
                console.log('ping!')
            } else {
                clearInterval(_me.state.setIntervalObj)
            }
        }, 240000)
    }

    componentWillUnmount () {
        clearInterval(this.state.setIntervalObj)
    }

    // 处理返回的数据
    message = (msg) => {
        const data = JSON.parse(msg)
        if (data.type === 1) { // 剩余额度
            const { productList } = this.state
            for (let i = 0; i < productList.length; i++) {
                if (productList[i].venueId === data.data.venueId) {
                    for (let j = 0; j < productList[i].productList.length; j++) {
                        if (productList[i].productList[j].key === data.data.key) {
                            productList[i].productList[j].restQuota = data.data.restQuota
                        }
                    }
                }
            }
            this.setState({
                productList: productList
            })
        }
        if (data.type === 2) { // 投资播报
            this.setState({
                broadcastList: data.data || []
            })
        }
        if (data.type === 3) { // 状态
            const { activitySliderList, broadcastList } = this.state
            let bankBroadcastList = broadcastList
            for (let i = 0; i < activitySliderList.length; i++) {
                for (let j = 0; j < data.data.length; j++) {
                    if (data.data[j].venueStatus === 2) {
                        bankBroadcastList = []
                    }
                    if (activitySliderList[i].venueId === data.data[j].venueId) {
                        activitySliderList[i].venueStatus = data.data[j].venueStatus
                    }
                }
            }
            this.setState({
                activitySliderList: activitySliderList,
                broadcastList: bankBroadcastList
            }, () => {
                // this.refs.childrenTimer.checkStatus();
                this.changeCurrentVenue(activitySliderList.find(item => item.selectStatus === 1))
            })
        }
    }

    // 重新链接websocket
    reconnect = () => {
        const {
            // list = [],
            titleData = {}
        } = this.props
        const { activitySliderList } = this.state
        if (titleData.activityId && activitySliderList && activitySliderList[activitySliderList.length - 1].venueStatus !== 3) {
            this.createWebsocket(titleData.activityId)
        }
    }

    // 点击投资记录
    handleRecord = (item) => {
        const { isLogin, activitySliderList } = this.state
        if (!isLogin) {
            if (websocket && activitySliderList && activitySliderList[activitySliderList.length - 1].venueStatus !== 3) {
                websocket.initiativeClose('去登录页面')
            }
            setLogin()
            return
        }
        if (item.urlType === '3') {
            this.setState({
                investRecordTitle: item.buttonText
            }, () => this.getInvestRecordList())
            return
        }
        if (item.urlType === '2') {
            if (websocket && activitySliderList && activitySliderList[activitySliderList.length - 1].venueStatus !== 3) {
                websocket.initiativeClose('去h5链接')
            }
            goIndex(item.url)
        }
    }

    // 获取投资记录
    getInvestRecordList = () => {
        const { activityId, businessLine } = this.props

        axios.get('/gateway/v1/activity/getInvestRecordList', {
            params: {
                activityId,
                businessLine
            }
        })
            .then(v => {
                if (v.data.data && v.data.data.length > 0) {
                    this.setState({
                        showInvestRecord: true,
                        InvestRecordList: v.data.data,
                        popupVisible: true
                    }, () => this.noSlide())
                } else {
                    Toast.info('暂无投资记录', 1)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    noSlide = () => {
        const { popupVisible } = this.state
        if (popupVisible) {
            document.body.style.position = 'fixed'
            document.body.style.width = '100%'
        } else {
            document.body.style.position = 'static'
        }
    }

    // 滑块之倒计时列表中的活动规则
    handleRule = (data) => {
        const { activitySliderList } = this.state
        if (data.urlType === '2') {
            if (websocket && activitySliderList && activitySliderList[activitySliderList.length - 1].venueStatus !== 3) {
                websocket.initiativeClose('去h5链接')
            }
            goIndex(data.url)
        }
        if (data.urlType === '3') {
            this.setState({
                ruleContentTitle: data.entryName,
                activityRuleContent: data.content,
                showActivityRule: true,
                popupVisible: true
            }, () => this.noSlide())
        }
    }

    // 滑块之倒计时列表中的活动规则之显示与隐藏
    handleShowRule = () => {
        this.setState({
            showActivityRule: !this.state.showActivityRule,
            popupVisible: !this.state.popupVisible
        }, () => this.noSlide())
    }

    // 滑块变化--产品列表随之变化
    changeCurrentVenue = (data) => {
        this.setState({
            currentVenue: data,
            activitySliderList: this.state.activitySliderList.map(item => item.venueId === data.venueId
                ? { ...item, selectStatus: 1 } : { ...item, selectStatus: 0 })
        }, () => this.refs.childrenTimer.checkStatus())
    }

    // 投资记录弹窗的关闭
    handleShowRecord = () => {
        this.setState({
            showInvestRecord: !this.state.showInvestRecord,
            popupVisible: !this.state.popupVisible
        }, () => this.noSlide())
    }

    // 总财富以及各业务线 金额是否加密切换
    handleChangeEncryptionStatus=(flag) => {
        this.setState({
            encryptionStatus: flag
        })
    }

    // 组件神策埋点
    buriedPointEvent=(info) => {
        const { pageTrackEvent } = this.props.titleData
        // 神策页面埋点
        pageTrackEvent && window.$webTrack(pageTrackEvent, info)
    }

    render () {
        const {
            isShow,
            // showDownload,
            isShareComponent,
            restQuotaBySocket,
            broadcastList,
            activitySliderList,
            showInvestRecord,
            isLogin,
            InvestRecordList,
            showActivityRule,
            activityRuleContent,
            productList,
            investRecordTitle,
            ruleContentTitle,
            currentVenue,
            encryptionStatus
        } = this.state
        const { list = [], titleData = {}, timeDiff, businessLine, activityId } = this.props
        return (
            <div
                style={{ background: titleData.backgroundColor || '#fff' }}
                className={`wrap ${isShow ? 'showBotton' : 'hideBotton'} ${isShareComponent ? 'padding-bottom' : ''}`}>
                {/* /!* 下载 *!/ */}
                {/* {titleData.isBootDownload === '1' && ( */}
                {/* <Download */}
                {/* downloadData={titleData} */}
                {/* showDownload={showDownload} */}
                {/* closeDownload={() => this.closeDownload()} */}
                {/* /> */}
                {/* )} */}
                {list.map(({ templateType, ...item }, index) => (
                    <React.Fragment key={templateType + index}>
                        {/* /!*广告模版 *!/ */}
                        {(templateType === 'TPL_ONE_PICTURE' ||
                            templateType === 'TPL_TWO_PICTURE' ||
                            templateType === 'TPL_THREE_PICTURE' || templateType === 'TPL_FOUR_PICTURE') && (
                            <Floor
                                data={item}
                                templateType={templateType}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 标题模板 */}
                        {templateType === 'TPL_TITLE' && (<Title data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* ‘推荐产品滑动1’、‘推荐产品滑动2’、‘混合产品列表1’、‘混合产品列表2’ */}
                        {templateType === 'TPL_INDEX_PRODUCT_SLIDE' && (<ProductIndex data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {templateType === 'TPL_MIXED_PRODUCT_SMALL_SLIDE' && (<ProductMixed data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {(templateType === 'TPL_INDEX_MIXED_PRODUCT_LIST' || templateType === 'TPL_INVEST_MIXED_PRODUCT_LIST') && (
                            <Product
                                data={item}
                                templateType={templateType}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 快捷入口 */}
                        {templateType === 'TPL_ENTEY' && (<QuickEntry data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* 轮播图 */}
                        {(templateType === 'TPL_BANNER_MARGIN' ||
                            templateType === 'TPL_BANNER_NOT_MARGIN') && (
                            <Vswiper
                                data={item}
                                templateType={templateType}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 吸底按钮 */}
                        {templateType === 'TPL_BOTTOM_BUTTON' && (<Mysubmit data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* 跳转到公众号按钮 */}
                        {templateType === 'TPL_GENERAL_BUTTON' && (<GeneralButton data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* 我的邀请 */}
                        {templateType === 'TPL_MY_INVITE' && (<InvitePanel data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* 邀请人信息 */}
                        {templateType === 'TPL_INVITEE_INFO' && (<InviterInfo data={item} />)}
                        {/* 分享 */}
                        {templateType === 'TPL_INVITE_SHARE' && (<Share data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* 统一抢购活动 之 投资记录 */}
                        {templateType === 'TPL_INVEST_RECORD' && (
                            <InvestRecord
                                isLogin={isLogin}
                                data={item}
                                handleRecord={this.handleRecord}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 统一抢购活动 之 活动场次滑块模板 */}
                        {templateType === 'TPL_ACTIVITY_VENUE_SLIDER' && (
                            <ActivitySlider
                                activitySliderList={activitySliderList}
                                data={item}
                                changeCurrentVenue={this.changeCurrentVenue}
                                timeDiff={timeDiff}
                                handleRule={this.handleRule}
                                ref={'childrenTimer'}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 统一抢购活动 之 活动场次产品列表模板 */}
                        {templateType === 'TPL_ACTIVITY_VENUE_PRODUCT_LIST' && (
                            <ProductItem
                                businessLine={businessLine}
                                websocket={websocket}
                                activitySliderList={activitySliderList}
                                activityId={activityId}
                                titleData={titleData}
                                data={item}
                                currentVenue={currentVenue}
                                isLogin={isLogin}
                                productList={productList}
                                restQuotaBySocket={restQuotaBySocket}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 统一抢购活动 之 投资播报模板 */}
                        {templateType === 'TPL_INVEST_BROADCAST' && (
                            <Broadcast
                                data={item}
                                broadcastList={broadcastList}
                                activitySliderList={activitySliderList}
                            />
                        )}
                        {/* 静态图 */}
                        {templateType === 'TPL_STATIC_DIAGRAM' && <StaticDiagram data={item} />}
                        {/* plus金融混合产品列表 */}
                        {templateType === 'TPL_PLUS_MIXED_PRODUCT_LIST' && (<ProductMixedByPlus data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* plus金融标题模板 */}
                        {templateType === 'TPL_PLUS_TITLE' && (<TitlePlus data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* plus金融VIP债转 */}
                        {templateType === 'TPL_PLUS_VIP_DEBT_TRANSFE' && (<DebtTransfer data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* plus金融易卡商城 */}
                        {templateType === 'TPL_PLUS_YK_SHOPPING_MALL' && (<ShoppingMallYika data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* plus金融易卡产品卡片 */}
                        {templateType === 'TPL_PLUS_YK_PRODUCT_CARD' && (<CardYika data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* plus金融我的资产 */}
                        {templateType === 'TPL_PLUS_MY_ASSET' && (<MyAsset data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* 公告模板 */}
                        {templateType === 'TPL_NOTICE' && (<Notice data={item} buriedPointEvent={this.buriedPointEvent} />)}
                        {/* 总财富 */}
                        {templateType === 'TPL_ASSETS_DISPLAY' && (
                            <WealthManagementCard
                                data={item}
                                encryptionStatus={encryptionStatus}
                                handleChangeEncryptionStatus={this.handleChangeEncryptionStatus}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 各业务线展示 */}
                        {templateType === 'TPL_BUSINESS_LINE_ASSETS' && (
                            <BusinessTemplate
                                data={item}
                                encryptionStatus={encryptionStatus}
                                buriedPointEvent={this.buriedPointEvent}
                            />
                        )}
                        {/* 业务线产品三栏展示 */}
                        {templateType === 'TPL_THREE_PRODUCT' && (<SanlianProducts data={item} buriedPointEvent={this.buriedPointEvent}/>)}
                        {/* 黄金TD */}
                        {templateType === 'TPL_GOLD_TD_PRODUCT' && (<GoldTD data={item} buriedPointEvent={this.buriedPointEvent}/>)}
                        {/* 易卡双卡 */}
                        {templateType === 'TPL_TWO_YK_PRODUCT_CARD' && (<LoanTwoColumns data={item} buriedPointEvent={this.buriedPointEvent}/>)}
                        {/* 员工专区 */}
                        {templateType === 'TPL_PLUS_EMPLOYEE_ENTRANCE' && (<EmployeeEntrance data={item} buriedPointEvent={this.buriedPointEvent}/>)}
                    </React.Fragment>
                ))}
                {showInvestRecord && <InvestmentDialog
                    InvestRecordList={InvestRecordList}
                    investRecordTitle={investRecordTitle}
                    handleShowRecord={this.handleShowRecord}
                />}
                {showActivityRule && <ActivityRuleDialog
                    activityRuleContent={activityRuleContent}
                    ruleContentTitle={ruleContentTitle}
                    handleShowRule={this.handleShowRule}
                />}
            </div>
        )
    }
}

export default ConfigPage
